module.exports = __webpack_public_path__ + "static/img/B.5292ad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jlbs/B.png
// module id = J9Ce
// module chunks = 0